<template>
	<div>
		<v-card class="px-3 py-5 mb-3" style="background-color: white;">
			<v-btn-toggle class="d-flex flex-wrap justify-center whitesmoke" v-model="localData.defaultThirdParty" color="secondary">
				<v-btn :value="tab.id" x-large v-for="tab in tabs" :key="tab.id">
					{{ tab.title }}
				</v-btn>
			</v-btn-toggle>
			<v-tabs v-model="activeTab" @change="tabChanged" class="mt-6 justify-center" background-color="transparent" color="secondary" slider-color="secondary">
				<v-tab :key="0">تنظیمات ارتباطی</v-tab>
				<v-tab :key="1" v-show="!entityType || tabMapper(1) == entityType">مشتریان</v-tab>
				<v-tab :key="2" v-show="!entityType || tabMapper(2) == entityType">وام ها</v-tab>
				<v-tab :key="3" v-show="!entityType || tabMapper(3) == entityType">اقساط</v-tab>
			</v-tabs>
			<v-slide-x-transition :hide-on-leave="true">
				<v-form ref="settings" class="mx-2" lazy-validation v-show="activeTab === 0">
					<v-card class="px-3 py-5 mb-3" style="background-color: #f1f1f1;">
						<v-card-text>
							<v-row v-if="localData.defaultThirdParty === 1">
								<v-col cols="12">
									<v-text-field outlined v-model="localData.landaSettings.token" class="left-input" label="توکن" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field outlined v-model="localData.landaSettings.bankId" class="left-input" label="شناسه بانک" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field outlined v-model="localData.landaSettings.cashId" class="left-input" label="شناسه صندوق" :error-messages="errorMessages" />
								</v-col>
							</v-row>
							<v-card color="whitesmoke" class="pa-2" v-if="localData.defaultThirdParty === 1">
								<v-row>
									<v-col cols="12">کد کالای معادل با هر وام در نرم افزار لاندا را ثبت نمایید.</v-col>
									<v-col cols="12" md="6" v-for="id in Object.keys((localData.landaSettings.productMap || {}))" :key="id" v-if="loans.some(x => x.id === id)">
										<div class="mb-2">{{ loans.find(x => x.id === id).title }}</div>
										<v-text-field outlined comfort v-model="localData.landaSettings.productMap[id]" class="left-input" label="" :error-messages="errorMessages" />
									</v-col>
								</v-row>
							</v-card>
							<v-row v-if="localData.defaultThirdParty === 2">
								<v-col cols="12">
									<v-text-field outlined v-model="localData.digibileSettings.secretKey" class="left-input" label="کلید امنیتی" :error-messages="errorMessages" />
								</v-col>
								<v-col cols="12">
									<v-switch v-model="localData.digibileSettings.isActive" label="سینک خودکار با دیجی بایل فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions>
							<v-spacer />
							<v-btn color="blue" :loading="loading" dark @click="submit()">
								ذخیره
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</v-slide-x-transition>
			<v-slide-x-transition :hide-on-leave="true">
				<v-card class="px-3 py-5 mb-3" style="background-color: #f1f1f1;" v-show="activeTab > 0">
					<v-row>
						<v-col cols="12" md="8">
							<v-radio-group v-model="onlySentItems" inline>
								<v-radio label="فقط آیتم های ارسال شده" color="secondary" :value="0"></v-radio>
								<v-radio label="فقط آیتم های ارسال نشده" color="secondary" :value="1"></v-radio>
								<v-radio label="همه آیتم ها" color="secondary" :value="2"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col cols="12" md="4" class="text-left">
							<v-btn color="info" :loading="loading" class="ml-1" small @click="loadData()">رفرش لیست</v-btn>
							<v-btn color="secondary" small @click="send()" :loading="sendLoading">ارسال اطلاعات</v-btn>
						</v-col>
					</v-row>
					<div>
						<div>
							<v-text-field @change="loadData" v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</div>
						<div class="pr-4">
							<v-checkbox color="secondary" v-model="selectAllToggler" label="انتخاب همه" @change="toggleSelectAll" />
						</div>
						<v-data-table :height="dataTableFixedHeight - 200" fixed-header :loading="loading" :options.sync="options" :server-items-length="count" dense :headers="headers" :items="items" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="itemsPerPage" :search="search" class="elevation-1">
							<!-- <v-data-table :height="dataTableFixedHeight - 200" fixed-header :loading="loading" dense :headers="headers" :items="items" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="itemsPerPage" :search="search" class="elevation-1"> -->
							<template v-slot:item.ch="{ item }">
								<v-checkbox color="secondary" v-model="item.ch" @change="(val) => updateSelectedItems(val, item)" />
							</template>
							<template v-slot:item.tag="{ item }">
								<div style="cursor: pointer;" @click="manageLoans(item)" class="info--text">{{ item.tag }}</div>
							</template>
							<template v-slot:item.landaTransfer="{ item }">
								<div v-if="localData.defaultThirdParty === 1">
									<div v-if="item.landaTransfer" style="white-space: pre-wrap;direction: ltr;">
										{{ item.landaTransfer }}
									</div>
									<div v-else class="red--text">
										ارسال نشده
									</div>
								</div>
								<div v-else-if="localData.defaultThirdParty === 2">
									<div v-if="item.digibileTransfer" style="white-space: pre-wrap;direction: ltr;">
										{{ item.digibileTransfer }}
									</div>
									<div v-else class="red--text">
										ارسال نشده
									</div>
								</div>
								<div v-else-if="localData.defaultThirdParty === 3">
									<div v-if="item.nikanTransfer" style="white-space: pre-wrap;direction: ltr;">
										{{ item.nikanTransfer }}
									</div>
									<div v-else class="red--text">
										ارسال نشده
									</div>
								</div>
							</template>
						</v-data-table>
					</div>
				</v-card>
			</v-slide-x-transition>
		</v-card>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import _ from 'lodash'
	import router from '@/router'

	export default {
		name: 'ThirdPartyView',
		props: {
			data: { type: Object },
			entityId: { type: String, default: '' },
			entityType: { type: String, default: '' },
		},
		data() {
			return {
				loans: [],
				lastActiveTab: 0,
				activeTab: 0,
				errorMessages: '',
				localData: { landaSettings: {} },
				onlySentItems: 1,
				options: null,
				selectAllToggler: false,
				search: '',
				count: 0,
				items: [],
				member: {
					items: [],
					onlySentItems: 1,
					search: '',
					count: 0,
				},
				userLoan: {
					items: [],
					onlySentItems: 1,
					search: '',
					count: 0,
					selectAllToggler: false
				},
				userLoanPayment: {
					items: [],
					onlySentItems: 1,
					search: '',
					count: 0,
					selectAllToggler: false
				},
				itemsPerPage: 25,
				loading: false,
				sendLoading: false,
				headers: [
					{
						text: '',
						align: 'start',
						sortable: false,
						value: 'ch',
						width: 10
					},
					{
						text: 'اطلاعات مشتری',
						align: 'start',
						sortable: true,
						value: 'entityTag',
						width: 200
					}, {
						text: 'اطلاعات ارسال',
						align: 'start',
						sortable: true,
						value: 'landaTransfer',
						width: 150
					}
				],
				tabs: [],
				selectedItems: [],
				previousSearch: null,
			}
		},
		mounted() {
			this.prepareTabs()
			this.loadLoans().then(() => {
				this.getSettings().then(() => {
					if (this.entityId && this.entityType) {
						this.onlySentItems = 2
						this.member.onlySentItems = 2
						this.userLoan.onlySentItems = 2
						this.userLoanPayment.onlySentItems = 2
						this.activeTab = this.entityType === 'User' ? 1 : this.entityType === 'UserLoan' ? 2 : 3
						if (this.localData.defaultThirdParty)
							this.loadData()
					}
				})
			})
		},
		computed: {
			...get('siteConfig', [
				'isCloud'
			]),
			...get('auth', [
				'getCurrentUser'
			])
		},
		watch: {
			options: {
				deep: true,
				handler(val, oldVal) {
					if (oldVal) {
						this.loadData()
					}
				},
			}
		},
		methods: {
			loadLoans() {
				return api.get('admin/loan/list', null)
					.then(response => {
						this.loans = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			tabMapper(tab) {
				let map = ['settings', 'User', 'UserLoan', 'UserLoanPayment']
				return map[tab]
			},
			viewDetail(item) {

			},
			toggleSelectAll() {
				this.items.forEach(x => x.ch = this.selectAllToggler)
				if (!this.selectAllToggler)
					this.selectedItems = []
				else
					this.selectedItems = [...this.items]
			},
			prepareTabs() {
				if (this.checkActivePart('thirdParty_Landa'))
					this.tabs.push({ id: 1, title: 'حسابداری لاندا' })
				if (this.checkActivePart('thirdParty_Digibile'))
					this.tabs.push({ id: 2, title: 'وب سایت دیجی بایل' })
				if (this.checkActivePart('thirdParty_Nikan'))
					this.tabs.push({ id: 3, title: 'حسابداری نیکان' })
			},
			submit() {
				if (this.$refs.settings && !this.$refs.settings.validate()) {
					this.activeTab = 0
					return
				}

				this.loading = true
				var data = _.cloneDeep(this.localData)
				api.post('admin/ThirdPartySettings/edit', data).then(x => {
					toast.success('اطلاعات با موفقیت ذخیره شد.')
				}).catch(err => {
					console.log("🚀 ~ api.post ~ err:", err)
					toast.error(err.message)
				}).finally(x => {
					this.loading = false
				})
			},
			getSettings() {
				return api.get('admin/ThirdPartySettings/Get')
					.then(response => {
						this.localData = response
						if (!this.localData.landaSettings?.productMap)
							this.localData.landaSettings.productMap = {}
						var landaProductMapKeys = Object.keys(this.localData.landaSettings.productMap)
						for (let loan of this.loans) {
							if (landaProductMapKeys.indexOf(loan.id) === -1)
								this.localData.landaSettings.productMap[loan.id] = ''
						}
						if (this.tabs.length === 1)
							this.localData.defaultThirdParty = this.tabs[0].id
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.loading = false
					})
			},
			loadData(e) {
				if (e === this.previousSearch)
					return
				this.previousSearch = this.search

				const url = this.onlySentItems === 0 ? 'admin/ThirdPartyTransfer/ListSent' : this.onlySentItems === 1 ? 'admin/ThirdPartyTransfer/ListNotSent' : 'admin/ThirdPartyTransfer/List'
				const data = {
					sortBy: this.options.sortBy,
					sortDesc: this.options.sortDesc,
					page: this.options.page || 1,
					itemsPerPage: this.options.itemsPerPage || this.itemsPerPage,
					search: this.search,
					entityType: this.tabMapper(this.activeTab),
					entityId: this.entityId,
					thirdParty: this.localData.defaultThirdParty
				}
				this.loading = true
				api.post(url, data)
					.then(response => {
						this.items = response.items
						this.count = response.countAll
						this.selectedItems = []
						// if (this.activeTab === '')
						// 	this.localData.defaultThirdParty = this.tabs[0].id
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.loading = false
					})
			},
			send() {
				if (!this.selectedItems.length) {
					toast.error('هیچ آیتمی جهت ارسال انتخاب نشده است.')
					return
				}
				const data = {
					entityType: this.tabMapper(this.activeTab),
					entityIds: this.selectedItems.filter(x => x.entityType === this.tabMapper(this.activeTab)).map(x => x.entityId),
					thirdParty: this.localData.defaultThirdParty
				}
				this.sendLoading = true
				api.post('admin/ThirdPartyTransfer/Send', data)
					.then(response => {
						for (let item in response) {
							let i = this.items.find(x => x.entityId === item)
							if (i) {
								let f = 'landaTransfer'
								switch (this.localData.defaultThirdParty) {
									case 1:
										f = 'landaTransfer'
										break
									case 2:
										f = 'digibileTransfer'
										break
									default:
										break
								}
								i[f] = response[item].value
							}
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(err => {
						this.sendLoading = false
					})
			},
			tabChanged(tab) {
				if (tab == 'settings')
					return

				if (this.tabMapper(this.lastActiveTab) === 'User') {
					this.member.count = this.count
					this.member.onlySentItems = this.onlySentItems
					this.member.search = this.search
					this.member.selectAllToggler = this.selectAllToggler
					this.member.items = [...this.items]
				} else if (this.tabMapper(this.lastActiveTab) === 'UserLoan') {
					this.userLoan.count = this.count
					this.userLoan.onlySentItems = this.onlySentItems
					this.userLoan.search = this.search
					this.userLoan.selectAllToggler = this.selectAllToggler
					this.userLoan.items = [...this.items]
				} else if (this.tabMapper(this.lastActiveTab) === 'UserLoanPayment') {
					this.userLoanPayment.count = this.count
					this.userLoanPayment.onlySentItems = this.onlySentItems
					this.userLoanPayment.search = this.search
					this.userLoanPayment.selectAllToggler = this.selectAllToggler
					this.userLoanPayment.items = [...this.items]
				}

				if (this.tabMapper(tab) === 'User') {
					this.count = this.member.count
					this.onlySentItems = this.member.onlySentItems
					this.search = this.member.search
					this.selectAllToggler = this.member.selectAllToggler
					this.items = [...this.member.items]
					this.headers.find(x => x.value === 'entityTag').text = 'اطلاعات مشتری'
				}
				else if (this.tabMapper(tab) === 'UserLoan') {
					this.count = this.userLoan.count
					this.onlySentItems = this.userLoan.onlySentItems
					this.search = this.userLoan.search
					this.selectAllToggler = this.userLoan.selectAllToggler
					this.items = [...this.userLoan.items]
					this.headers.find(x => x.value === 'entityTag').text = 'اطلاعات وام'
				}
				else if (this.tabMapper(tab) === 'UserLoanPayment') {
					this.count = this.userLoanPayment.count
					this.onlySentItems = this.userLoanPayment.onlySentItems
					this.search = this.userLoanPayment.search
					this.selectAllToggler = this.userLoanPayment.selectAllToggler
					this.items = [...this.userLoanPayment.items]
					this.headers.find(x => x.value === 'entityTag').text = 'اطلاعات قسط'
				}
				this.lastActiveTab = tab
			},
			updateSelectedItems(state, row) {
				if (!row)
					return
				const index = this.selectedItems.findIndex(x => x.id === row.id)
				if (state) {
					if (index === -1)
						this.selectedItems.push(row)
				} else {
					if (index !== -1)
						this.selectedItems.splice(index, 1)
				}
			},
		},
	}
</script>
<style></style>
